import React, {Component} from "react";
import Pagination from "react-js-pagination";
import PropTypes from "prop-types";

const propTypes = {
	current: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	nextPage: PropTypes.func.isRequired,
	perPage: PropTypes.number
}

const defaultProps = {
	perPage: 20
}

class InmPagination extends Component {
	render() {
		return (<Pagination
			hideDisabled
			activePage={this.props.current}
			itemsCountPerPage={this.props.perPage}
			totalItemsCount={this.props.total}
			prevPageText={<i className="fa fa-angle-left" />}
			nextPageText={<i className="fa fa-angle-right" />}
			firstPageText={<i className="fa fa-angle-double-left" />}
			lastPageText={<i className="fa fa-angle-double-right" />}
			onChange={this.handlePageChange.bind(this)}
			key="users-pages"
		/>)
	}

	constructor() {
		super();
		this.handlePageChange = this.handlePageChange.bind(this);
	}

	handlePageChange(values) {
		this.props.nextPage(values);
	}
}

InmPagination.propTypes = propTypes;
InmPagination.defaultProps = defaultProps;

export default InmPagination;


// WEBPACK FOOTER //
// ./src/elements/widgets/inmPagination.jsx